import { render, staticRenderFns } from "./stockUpStat_v2.vue?vue&type=template&id=6fe6f178&"
import script from "./stockUpStat_v2.vue?vue&type=script&lang=js&"
export * from "./stockUpStat_v2.vue?vue&type=script&lang=js&"
import style0 from "./stockUpStat_v2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "stockUpStat_v2.vue"
export default component.exports